import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { checkoutUrl, offer } from '../data/offer';
import { trackPixelEvent } from '../utils/metaPixel';
interface CtaButtonProps {
  label: string;
  /** Shorter label used on phones so the button never wraps past two lines. */
  mobileLabel?: string;
  note?: string;
  size?: 'default' | 'large';
  fullWidth?: boolean;
  /** Where the click happened, sent to the pixel so placements can be compared. */
  placement: string;
}
export function handleCheckoutClick(placement: string): void {
  trackPixelEvent('InitiateCheckout', {
    content_name: offer.productName,
    value: offer.price,
    currency: offer.currency,
    placement
  });
}
export function CtaButton({
  label,
  mobileLabel,
  note,
  size = 'default',
  fullWidth = false,
  placement
}: CtaButtonProps) {
  const isLarge = size === 'large';
  return <div className="flex w-full flex-col items-center" data-id="element-67" data-mp="159gcukyxmdxk">
      <a href={checkoutUrl} rel="noopener" onClick={() => handleCheckoutClick(placement)} className={['group inline-flex w-full items-center justify-center gap-3 rounded-full bg-gold text-center font-semibold uppercase leading-tight tracking-[0.05em] text-night', 'shadow-gold transition-[transform,background-color] duration-150 ease-expo', 'hover:-translate-y-0.5 hover:bg-gold-soft active:translate-y-0', isLarge ? 'px-6 py-4 text-sm sm:px-12 sm:py-5 sm:text-base' : 'px-6 py-4 text-xs sm:px-9 sm:text-sm', fullWidth ? '' : 'sm:w-auto'].join(' ')} data-id="element-68" data-mp="15arjcsjrhzsd">
        {mobileLabel ? <>
            <span className="sm:hidden" data-id="element-69" data-mp="1jpsw8ehecrp">{mobileLabel}</span>
            <span className="hidden sm:inline" data-id="element-70" data-mp="6iaofuisg89t">{label}</span>
          </> : label}
        <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-expo group-hover:translate-x-1" aria-hidden="true" data-id="element-71" data-mp="bif2ldw84qwv" />
      </a>
      {note && <p className="mt-3 text-center text-xs font-medium leading-snug text-cream-muted" data-id="element-72" data-mp="3my8pvmf4cj23">{note}</p>}
    </div>;
}